import service from '../../config/axios.config';

export const fetchTodos = ({ objectiveId }) =>
  service.get(`objectives/${objectiveId}/todos`);

export const createTodo = ({ objectiveId, todo }) =>
  service.post(`objectives/${objectiveId}/todos`, todo);

export const updateTodo = ({ objectiveId, todo }) =>
  service.put(`objectives/${objectiveId}/todos/${todo.id}`, todo);

export const deleteTodo = ({ objectiveId, todoId }) =>
  service.delete(`/objectives/${objectiveId}/todos/${todoId}`);
